import { css } from "@emotion/react";
import { useState } from "react";
import { Tip } from "../../../consts";

type TipsProps = {
  tip: Tip;
};

const Tips: React.FC<TipsProps> = ({ tip }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      css={css`
        background-color: #fff;
        padding: 24px;
        border: 1px solid #e63c3c;
        border-radius: 34px;
      `}
    >
      <div>
        <h3
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #e63c3c;
            cursor: pointer;
          `}
          onClick={() => setOpen((v) => !v)}
        >
          <span>{tip.title}</span>
          <button
            css={[
              css`
                background-color: transparent;
                border: 0;
                color: #e63c3c;
                transition: transform 0.3s;
              `,
              open
                ? css`
                    transform: scale(1, -1);
                  `
                : css``,
            ]}
            onClick={() => setOpen((v) => !v)}
          >
            ▼
          </button>
        </h3>
      </div>
      <div
        css={[
          css`
            margin-top: 16px;
            padding-top: 16px;
            border-top: 1px solid #e63c3c;
            display: none;
          `,
          open
            ? css`
                display: block;
              `
            : null,
        ]}
      >
        <p>{tip.text}</p>
        {tip.title === "Makimono" && (
          <img
            css={css`
              margin-top: 16px;
            `}
            src="img/emaki.png"
            alt=""
          />
        )}
      </div>
    </div>
  );
};

export default Tips;
